import dayjs from 'dayjs';
import { isNil } from 'lodash';

import { SHORT_MONTH_DAY_YEAR_FORMAT } from 'constants/date';

import { COMPANY_VOLUME_AS_OF_PREFIX } from './companyVolume.constants';

const getCompanyVolumeAsOfLabel = ({ windowDays, asOf }) => {
  const windowFragment = isNil(windowDays) ? '' : `trailing ${windowDays}d`;
  const asOfFragment = isNil(asOf)
    ? ''
    : `${COMPANY_VOLUME_AS_OF_PREFIX} ${dayjs(asOf).format(SHORT_MONTH_DAY_YEAR_FORMAT)}`;

  return [windowFragment, asOfFragment].filter(Boolean).join(' · ');
};

/**
 * Maps the company-volume endpoint into the bare funded-unit count display shape.
 * Returns null when the response is missing so the reducer holds its empty state.
 * @param {object|null} data - { fundedUnits, windowDays, asOf }
 * @returns {object|null}
 */
export const mapCompanyVolume = data => {
  if (isNil(data)) {
    return null;
  }

  return {
    fundedUnits: data.fundedUnits ?? 0,
    windowDays: data.windowDays ?? null,
    asOf: data.asOf ?? null,
    asOfLabel: getCompanyVolumeAsOfLabel({ windowDays: data.windowDays, asOf: data.asOf }),
  };
};
